<template>
  <div class="row-test">
    <v-row justify="center">
      <v-col cols="7">
        <vacancy-title />
      </v-col>
    </v-row>

    <div class="headhunter__body">
      <v-row justify="center">
        <v-col cols="7">
          <div class="headhunter__btns">
            <div :class="['headhunter__btn', { active: showCommonTab }]" @click="showCommonTab = true">
              <span>
                {{ $tr('common.navigation.settings') }}
              </span>

              <img
                v-tooltip="{
                  content:
                    'Вы можете просмотреть и привязать необходимые вакансии из Headhunter к текущей вакансии VCV. По данным вакансиям будут автоматически отправляться приглашения всем откликнувшимся на вакансию в Headhunter',
                  placement: 'top-center',
                  classes: 'tight tight-330'
                }"
                class="vmodule_icon-lock"
                src="/static/images/elements/vmodule-icon-info.svg"
              />
            </div>

            <div :class="['headhunter__btn', { active: !showCommonTab }]" @click="showCommonTab = false">
              <span>
                {{ $tr('integration.headhunter.autosearch') }}
              </span>

              <img
                v-tooltip="{
                  content: $tr('integration.headhunter.autosearch-tooltip'),
                  placement: 'top-center',
                  classes: 'tight tight-330'
                }"
                class="vmodule_icon-lock"
                src="/static/images/elements/vmodule-icon-info.svg"
              />
            </div>
          </div>

          <div v-if="showCommonTab" class="headhunter__list">
            <div v-if="headhunterApiAccess === null || !headhunterApiAccess.default">
              <template v-if="isHeadhunterLoading">
                <vpreloader width="2" size="64" />
              </template>

              <template v-else>
                Проверьте авторизованы ли вы в настройках
                <router-link tag="a" :to="{ name: 'settings-integrations' }"> интеграции </router-link>
                Headhunter
                <br />
                <br />
                У вашей компании также должен быть опаченный доступ к API Headhunter
              </template>
            </div>

            <template v-else>
              <vbutton
                v-tooltip.bottom="
                  'Ручное обновление списка из headhunter, можно запрашивать данные не чаще 5 раз в час'
                "
                class="headhunter__btns-refresh"
                text="Обновить данные"
                :loading="vacanciesHeadhunterLoading"
                size="small"
                @click="startHeadhunterSyncVacancies"
              />

              <v-table
                :headers="vacanciesTableHeader"
                :loading="vacanciesHeadhunterLoading"
                :items="vacanciesHeadhunterForTable"
                :is-show-actions="false"
              >
                <template #header="{ header }">
                  <vcv-vacancy-headhunter-tablehead
                    :header="header"
                    :sorting="sorting"
                    :show-filter="showFilter"
                    :filter-title-selected="vacanciesHeadhunterFilters.filterTitleSelected"
                    :filter-region-selected="vacanciesHeadhunterFilters.filterRegionSelected"
                    :filter-author="getHeadhunterManagers"
                    :filter-author-selected="vacanciesHeadhunterFilters.filterAuthorSelected"
                    @set-show-filter="setShowFilter"
                    @set-temp-title="setFilterTitle"
                    @set-temp-region="setFilterRegion"
                    @set-temp-author="setFilterAuthors"
                    @apply-filter="applyFilter"
                  />
                </template>

                <template #row-action="{ cell }">
                  <div class="headhunter__actions">
                    <!-- vcvVacancy.id != cell.vcvVacancyId && cell.isVacancyAssigned - это условие если вакансия привязана к другой вакансии -->
                    <trigger
                      class="headhunter__switcher"
                      :value="
                        vcvVacancy.id != cell.vcvVacancyId && cell.isVacancyAssigned
                          ? !cell.isVacancyAssigned
                          : cell.isVacancyAssigned
                      "
                      :disabled="
                        switcherLoading === Number(cell.id) ||
                        (vcvVacancy.id != cell.vcvVacancyId && cell.isVacancyAssigned)
                      "
                      @input="toggleActiveHeadhunterVacancy(cell, !cell.isVacancyAssigned)"
                    />

                    <span v-if="vcvVacancy.id != cell.vcvVacancyId && cell.isVacancyAssigned" class="media-info-text">
                      <img
                        v-tooltip="{
                          content: `
                              Данная Headhunter-вакансия уже привязана к VCV-вакансии
                              ${getVacancyTitle(cell.vcvVacancyId)}
                            `,
                          placement: 'left',
                          classes: 'tight'
                        }"
                        class="vmodule_icon-lock"
                        src="/static/images/elements/vmodule-icon-info.svg"
                      />
                    </span>
                  </div>
                </template>
              </v-table>

              <vcv-pagination
                :params="vacanciesHeadhunterPagination"
                :is-loading="vacanciesHeadhunterLoading"
                is-left
                show-counts
                @on-page-change="onPageChange"
                @on-limit-change="onLimitChange"
              />
            </template>
          </div>

          <vcv-vacancy-headhunter-autosearch v-else :vcv-vacancy-id="vcvVacancy.id" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import VTable from '@/components/table';
import VcvVacancyHeadhunterTablehead from '@/routes_new/inner/vacancy/integrations/VcvVacancyHeadhunterTablehead';
import VcvVacancyHeadhunterAutosearch from '@/routes_new/inner/vacancy/integrations/VcvVacancyHeadhunterAutosearch';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import VacancyTitle from '@/routes_new/inner/vacancy/components/vtitle';
import VcvPagination from '@/components_new/complex/VcvPagination';
import Trigger from '@/components/shared/Trigger';

export default {
  name: 'VacancyHeadhunter',

  components: {
    VTable,
    VacancyTitle,
    VcvVacancyHeadhunterTablehead,
    VcvVacancyHeadhunterAutosearch,
    VcvPagination,
    Trigger
  },

  data() {
    return {
      switcherLoading: null,
      vacanciesTableHeader: [
        {
          id: 'id',
          is_visible: false,
          is_base: true,
          name: '#',
          width: ''
        },
        {
          id: 'title',
          is_visible: true,
          is_base: true,
          name: 'Название',
          width: ''
        },
        {
          id: 'region',
          is_visible: true,
          is_base: true,
          name: 'Регион',
          width: ''
        },
        {
          id: 'responses_count',
          is_visible: true,
          is_base: false,
          name: 'Откликов',
          width: ''
        },
        {
          id: 'manager_id',
          is_visible: true,
          is_base: true,
          name: 'Автор',
          width: ''
        },
        {
          id: 'row-action',
          is_visible: true,
          is_base: true,
          name: this.$tr('integrations.connect'),
          width: ''
        }
      ],

      showCommonTab: true,
      showFilter: 'none',
      sorting: {
        name: 'created_at',
        order: 'desc'
      },

      vcvVacancies: []
    };
  },

  computed: {
    ...mapState('integrationsHeadhunter', [
      'vacanciesHeadhunter',
      'vacanciesHeadhunterLoading',
      'vacanciesHeadhunterPagination',
      'vacanciesHeadhunterFilters',
      'headhunterApiAccess',
      'isHeadhunterLoading'
    ]),

    ...mapGetters('integrationsHeadhunter', ['getHeadhunterManagerById', 'getHeadhunterManagers']),

    ...mapGetters('vacancy_new', { vcvVacancy: 'item' }),

    vacanciesHeadhunterForTable() {
      return this.vacanciesHeadhunter.map(x => {
        const hhVacancyId = x._embedded !== undefined ? `(${x.hh_vacancy_id})` : '';
        const title = `${x.title} ${hhVacancyId}`;
        let manager = '-';
        if (x._embedded.manager !== undefined) {
          manager = `${x._embedded.manager.full_name} (${x._embedded.manager.email})`;
        }

        return {
          id: x.id,
          title: title,
          region: x.region,
          responses_count: String(x.responses_count),
          manager_id: manager,
          // Если _embedded пустой и не содержит объекта vacancy, то значит связи с vcv нет, то есть active = false
          isVacancyAssigned: x._embedded.vacancy === undefined ? false : true,
          hhVacancyId: x.hh_vacancy_id,
          integrationVacancyId: x._embedded.vacancy !== undefined ? x._embedded.vacancy.id : null,
          vcvVacancyId: x._embedded.vacancy !== undefined ? x._embedded.vacancy.vcv_vacancy_id : null
        };
      });
    },

    filterAuthor() {
      let authors = [];

      for (let i = 0; i < this.vacanciesHeadhunter.length; i++) {
        if (authors.findIndex(x => x.id === this.vacanciesHeadhunter[i].manager_id) < 0) {
          authors.push({
            id: this.vacanciesHeadhunter[i].manager_id,
            name: `
              ${this.getHeadhunterManagerById(this.vacanciesHeadhunter[i].manager_id).fullName}
              (${this.getHeadhunterManagerById(this.vacanciesHeadhunter[i].manager_id).email})
            `
          });
        }
      }

      return authors;
    }
  },

  async created() {
    if (this.headhunterApiAccess === null) {
      await this.fetchApiAccess();
    }

    await this.fetchVacanciesFromHeadhunter();
    await this.fetchHeadhunterManagers();

    await this.fetchVacanciesTitle();
  },

  methods: {
    ...mapActions('integrationsHeadhunter', [
      'fetchHeadhunterManagers',
      'fetchVacanciesFromHeadhunter',
      'connectVacancyToVcv',
      'removeVacancyFromVcv',
      'fetchApiAccess',
      'startHeadhunterSyncVacancies'
    ]),

    ...mapMutations('integrationsHeadhunter', [
      'SET_PAGINATION_PARAMS_PAGE',
      'SET_PAGINATION_PARAMS_LIMIT',
      'SET_FILTER_TITLE',
      'SET_FILTER_REGION',
      'SET_FILTER_AUTHORS'
    ]),

    async fetchVacanciesTitle() {
      let queryParams = '';

      this.vacanciesHeadhunter.forEach(x => {
        if (x._embedded.vacancy !== undefined && x._embedded.vacancy.id !== undefined) {
          queryParams += `&filter[id][]=${x._embedded.vacancy.vcv_vacancy_id}`;
        }
      });

      queryParams = queryParams.slice(1);

      await Axios.get(`/v3/vacancies?${queryParams}`).then(response => {
        if (response.data._embedded.vacancies) {
          this.vcvVacancies = response.data._embedded.vacancies;
        }
      });
    },

    getVacancyTitle(vcvVacancyId) {
      const vacancy = this.vcvVacancies.find(x => x.id == vcvVacancyId);

      if (vacancy !== undefined && vacancy.title !== undefined) {
        return vacancy.title;
      }

      return '';
    },

    async toggleActiveHeadhunterVacancy(item, isActive) {
      this.switcherLoading = item.id;

      if (isActive) {
        const params = {
          active: true,
          vcv_vacancy_id: Number(this.vcvVacancy.id),
          hh_vacancy_id: item.hhVacancyId
        };

        await this.connectVacancyToVcv({ vacancyId: item.id, params: params }).finally(() => {
          this.switcherLoading = null;
        });
      } else {
        this.removeVacancyFromVcv(item).finally(() => {
          this.switcherLoading = null;
        });
      }
    },

    async onPageChange(val) {
      this.SET_PAGINATION_PARAMS_PAGE(val);

      await this.fetchVacanciesFromHeadhunter();
    },

    async onLimitChange(val) {
      this.SET_PAGINATION_PARAMS_LIMIT(val);
      this.SET_PAGINATION_PARAMS_PAGE(1);

      await this.fetchVacanciesFromHeadhunter();
    },

    setShowFilter(v) {
      this.showFilter = v;
    },

    setFilterTitle(v) {
      this.SET_FILTER_TITLE(v);
    },

    setFilterRegion(v) {
      this.SET_FILTER_REGION(v);
    },

    setFilterAuthors(v) {
      this.SET_FILTER_AUTHORS(v);
    },

    async applyFilter() {
      this.SET_PAGINATION_PARAMS_PAGE(1);

      await this.fetchVacanciesFromHeadhunter();
    }
  }
};
</script>

<style lang="scss" scoped>
.headhunter {
  &__btns {
    display: flex;
    border-radius: 4px;
    margin-bottom: 30px;
  }

  &__btns-refresh {
    margin-bottom: 20px;
  }

  &__btn {
    width: 50%;
    font-size: 15px;
    padding: 10px 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    border-top: 1px solid #d2d6e0;
    border-bottom: 1px solid #d2d6e0;
    border-left: 1px solid #d2d6e0;
    border-right: none;
    transition: all linear 0.4s;

    > img {
      margin-left: 10px;
    }

    &:last-child {
      border-right: 1px solid #d2d6e0;
    }

    &:hover {
      background: #f4f5f7;
    }

    &.active {
      background: #f4f5f7;
    }
  }

  &__list-header {
    display: flex;
    justify-content: space-between;
  }

  &__search {
    margin-bottom: 20px;
  }

  &__list-item,
  &__list-header {
    display: flex;
    position: relative;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    padding: 15px 25px;
    align-items: center;
    min-height: 60px;
  }

  &__list-item-loader {
    background: rgba(255, 255, 255, 0.6);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  &__list-header {
    font-weight: bold;
    background: #eee;
    padding: 25px;
    margin-top: 20px;
  }

  &__list-item-text {
    width: 40%;
    max-width: 40%;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 1.6;
    padding-right: 15px;

    span {
      color: #a6a6a6;
      font-size: 14px;
    }
  }

  &__list-item-action {
    width: 20%;
    display: flex;
    align-items: center;
  }

  &__actions {
    display: flex;
    align-items: center;

    .media-info-text {
      line-height: 1;
    }
  }

  &__switcher {
    margin-right: 10px;
  }

  &__list,
  &__loader {
    margin-bottom: 100px;
  }

  &__list-empty {
    color: #aaa;
    font-size: 18px;
    text-align: center;
    padding: 50px;
  }

  &__pagination {
    margin-top: 30px;
  }
}
</style>
